import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import './login-form.scss'
import { logInWithEmailAndPassword } from '../../../utils/auth';

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email("Enter a valid email address")
    .required("Email is required"),
  password: Yup.string()
    .required("Password/PIN is required")
    .min(5, "Password/PIN is too short - Should be 5 characters minimum")
    .matches(
      /^(?=.*?[A-Z])(?=.*?[0-9])/,
      "Password should have at least one uppercase letter and one number"
    ),
});

const LoginForm = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = (values) => {
    setIsLoading(true);
    logInWithEmailAndPassword(values.email, values.password).then(res => {
      setIsLoading(false);
      navigate("/");
    }).catch(err => {
      setIsLoading(false);
      switch (err.code) {
        case "auth/Invalid-email":
          setErrorMessage("Invalid Email Address")
          break;
        case "auth/user-disabled":
          setErrorMessage("Account Disabled")
          break;
        case "auth/user-not-found":
          setErrorMessage('Account Not Found')
          break;
        case "auth/wrong-password":
          setErrorMessage("Wrong Email or Password")
          break;
        default:
          setErrorMessage("Error Loggin In")
      }
    })
  };

  return (
    <div className="login-form">
      <div className="login-error">{errorMessage ? errorMessage : ""}</div>
      <Formik
        initialValues={{
          email: "",
          password: "",
        }}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
        validationSchema={loginSchema}
      >
        {({ handleSubmit, values, handleChange, errors, touched }) => (
          <form onSubmit={handleSubmit}>
            <div className={`field`}>
              <label htmlFor="email">email</label>
              <input
                name="email"
                id="email"
                placeholder="Enter Email"
                value={values.email}
                onChange={handleChange}
              />
              {errors.email && touched.email ? (
                <div className="error">{errors.email}</div>
              ) : null}
            </div>
            <div className={`field password`}>
              <label htmlFor="password">Password/PIN</label>
              <input
                name="password"
                id="password"
                type="password"
                placeholder="Enter your password or PIN"
                value={values.password}
                onChange={handleChange}
              />
              {errors.password && touched.password ? (
                <div className="error">{errors.password}</div>
              ) : null}
              {/* <Link to={"/"} className={'forgot-password'}>Forgot password?</Link> */}
            </div>
            <button type="submit" disabled={isLoading}>
              {!isLoading && <span>Login</span>}
              {isLoading && <span>Loggin in</span>}
              {/* {isLoading && <Loader />} */}
            </button>
          </form>
        )}
      </Formik>

      <p>
        Forgot your password ? <Link to={"/reset-password"}>Reset here</Link>
      </p>
    </div>
  );
};

export default LoginForm;
